<template>
    <div class="row pt-3">
    <div class="col">
     <h2 class="mb-0">Kitap Listesi</h2>
    </div>
    <div class="menu" style="  width: 110px;">
      <p>
      <a href="/">Üyelik Formu</a>
    </p>
    </div>
    </div>
    <div v-if="kitap_listesi" class='row'>
        <div class="col-lg-12 ofset-lg-2">
            <div class="table-responsice">
                <DataTable class="table table-stripeds table-bordereds display"
                style="width:100%"
                :data="kitap_listesi"
                :columns="stunlar"
                :options="datatablesettings"
                >
                <thead>
            <tr>
            <th v-for="(item, index) in stunlar" :key="index">{{item.name}}</th>
            </tr>
            </thead>
            </DataTable>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    import axios from 'axios'

import DataTable from 'datatables.net-vue3'
import DataTableLib from 'datatables.net-bs5'
import responsible from 'datatables.net-responsive-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.css'

//import { Swal } from 'sweetalert2/dist/sweetalert2'
//import 'datatables.net-rowreorder-bs5'
//import 'datatables.net-rowgroup-bs5'
//import 'datatables.net-keytable-bs5'
//import 'datatables.net-fixedcolumns-bs5'
//import 'datatables.net-fixedheader-bs5'
//import 'datatables.net-select-bs5'
//import 'datatables.net-searchbuilder-bs5'
//import 'datatables.net-staterestore-bs5'

DataTable.use(DataTableLib)
DataTable.use(responsible)



    const columss = [
    { data: 'kitap_adi',name:'Kitap Adı' },
    { data: 'yazar',name:'Yazar' },
    { data: 'yayin_evi',name:'Yayınevi' },
    { data: 'musait_adet',name:'Uygunluk',
        "render": function ( data ) {
            let durum;
            if(data > 0){ durum = "Alınabilir"} else { durum = "Üyeden dönüşü bekleniyor"}
        return durum
    }
    },
    ];

    export default {
    name: 'HomeView',
    components: {
    DataTable
  },
    data () {
            return {
            datatablesettings:{
                    autoWidth:false,
                    select:true,
                    dom:'Bfrtip',
                    "language":{url: "https://kutuphane.adalarmuzesi.org/datatable-tr.json"},
                    responsive: { details: {type: 'column', target: 'tr'} },
                    lengthMenu: [ [ 20, 50, 100, -1 ], [ '20 Kayıt', '50 Kayıt', '100 Kayıt', 'Tümünü Göster' ],],
                },  
            kitap_listesi:'',
            stunlar:columss,
            islem_url:'https://api2.adalarvakfi.org/kutuphane/kitap_listesi.php',
                }
            },
   
    created (){
       this.liste_getir()
    },
    methods:{
      
        liste_getir:function(){  
              axios({
                  method: 'post',
                  responseType: 'json',
                  url: this.islem_url,
              }).then((response) => {
                console.log(response.data.cevap)
                this.kitap_listesi = response.data.cevap
                 })
        }
  }
}

  </script>
  
  <style>
  .container{
    max-width: 800px !important;
  }


.menu p a{
  color: rgb(0, 34, 155);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 700;
}
table{
    font-size: 0.8rem !important;
}
</style>